import React, {useEffect, useState} from 'react';
import  { Redirect } from 'react-router-dom'
import guService from "../../services/guService";
import {trackPromise} from "react-promise-tracker";
import Swal from "sweetalert2";

export default function Validacao() {

  const [dados, setDados] = useState({});
  const [message, setMessage] = useState('Aguarde...');

  useEffect(() => {
    guService.usuario.buscaDadosModulos().then(res => {
      setDados(res.data);
    }).catch(err => Swal.fire({
        titleText: "Erro",
        text: "Houve um problema ao buscar a  " + err,
        icon: 'error'
      })
    )
  }, [])


  function acessarModulo() {
    trackPromise(
      guService.modulo.acessar(dados.modulo_redirecionar).then(res => {
        const {modulo, token} = res.data;
        window.location  = (modulo.uri + token);
      }).catch(err => {
        Swal.fire({
          titleText: "Erro",
          text: "Houve um problema ao autorizar acesso ao módulo " + err,
          icon: 'error'
        });
      })
    );
  }


  useEffect(() => {
    if(dados.clients_count >= 1 || dados.modules_count >= 1) {
      return window.location = '/dashboard'
    }
    // if(dados.clients_count === 1 && dados.modules_count === 1) {
    //   acessarModulo()
    // }

    if(dados.clients_count === 0) {
      setMessage('você não tem nenhuma incorporadora vinculada, entre em contato com e solicite seu acesso');
    }

    if(dados.clients_count === 1 && dados.modules_count === 0) {
      setMessage('você não tem nenhum módulo vinculado, entre em contato com a incorporadora e solicite seu acesso');
    }


  },[acessarModulo, dados])



  return (<>{message}</>);
}
